import {
  formatLedgerAmount,
  formatLedgerDateTime,
  isLedgerCredit,
  ledgerRowNote,
  ledgerTypeLabel,
  type MachineBalanceRow,
} from '@/domain/transactions';
import { cn } from '@/lib/cn';

export interface TransactionLedgerRowProps {
  row: MachineBalanceRow;
  currency?: string;
  className?: string;
  cashLabel?: string;
  bonusLabel?: string;
}

export function TransactionLedgerRow({
  row,
  currency = '',
  className,
  cashLabel = 'Cash',
  bonusLabel = 'Bonus',
}: TransactionLedgerRowProps) {
  const credit = isLedgerCredit(row);
  const typeLabel = ledgerTypeLabel(row.Type);
  const note = ledgerRowNote(row);
  const amountClass = cn(
    'text-[14px] font-bold',
    credit ? 'text-status-success' : 'text-text-primary',
  );

  return (
    <article
      className={cn(
        'flex items-center gap-4 rounded-sm border border-border-subtle bg-bg-surface px-4 py-3.5',
        className,
      )}
    >
      <div className="flex min-w-0 flex-1 flex-col gap-1 overflow-hidden">
        <p className="truncate text-[14px] font-bold text-text-primary">
          {typeLabel || '—'}
        </p>
        {note ? (
          <p className="truncate text-[12px] text-text-secondary">{note}</p>
        ) : null}
        <p className="text-[11px] text-text-secondary">{formatLedgerDateTime(row.Date)}</p>
      </div>

      <div className="flex shrink-0 gap-5 text-right">
        <div className="flex flex-col items-end gap-1">
          <p className="text-[10px] text-text-secondary">{cashLabel}</p>
          <p className={amountClass}>{formatLedgerAmount(row.Value, currency)}</p>
          <p className="text-[12px] text-text-secondary">
            {formatLedgerAmount(row.Credits, currency)}
          </p>
        </div>
        <div className="flex flex-col items-end gap-1">
          <p className="text-[10px] text-text-secondary">{bonusLabel}</p>
          <p className={amountClass}>{formatLedgerAmount(row.BonusValue, currency)}</p>
          <p className="text-[12px] text-text-secondary">
            {formatLedgerAmount(row.BonusCredits, currency)}
          </p>
        </div>
      </div>
    </article>
  );
}
